import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

// Leaflet calcula su tamaño al montar. Si en ese momento el contenedor
// todavía se está animando (un IonModal abriéndose, una hoja tipo sheet) o
// estaba oculto (una pestaña que no era la activa), el mapa queda con un
// tamaño viejo y solo pinta una franja. Lo recalculamos cada vez que el
// contenedor cambia de tamaño, sin importar la causa.
export default function MapAutoResize() {
  const map = useMap();

  useEffect(() => {
    const container = map.getContainer();
    const observer = new ResizeObserver(() => map.invalidateSize());
    observer.observe(container);
    return () => observer.disconnect();
  }, [map]);

  return null;
}
